<template>
  <radio-buttons v-bind="$attrs" @input="$emit('input', $event)">
    <template v-slot:feedback="{ valid, errors }">
      <b-form-invalid-feedback :state="valid">
        <div v-for="(error, idx) in errors" :key="idx" class="form-group col-md-6 offset-md-3 col-sm-12">
          <p class="text-center"><i class="fal fa-exclamation-circle"></i> {{ error }}</p>
        </div>
      </b-form-invalid-feedback>
    </template>
  </radio-buttons>
</template>
<script>
import RadioButtons from '@/shared/inputs/radio_buttons.vue'

export default {
  components: { RadioButtons },
}
</script>
